import { apiClient } from './client';
import { API_ROUTES } from './routes';

export const userService = {
  async getMe() {
    const response = await apiClient.get(API_ROUTES.USERS.ME);
    return response?.data || null;
  },

  async getUsage() {
    const response = await apiClient.get(API_ROUTES.USERS.USAGE);
    return response?.data || null;
  },

  async updateProfile(payload) {
    const response = await apiClient.put(API_ROUTES.SETTINGS.PROFILE, payload);
    return response?.data || null;
  },

  async updatePhoneNumber(phoneNumber) {
    // Update phone number immediately, independent from onboarding survey
    const response = await apiClient.put(API_ROUTES.SETTINGS.PROFILE, {
      phone_number: phoneNumber
    });
    return response?.data || null;
  },

  async completeOnboarding(data) {
    const response = await apiClient.post(API_ROUTES.USERS.ONBOARDING, data);
    return response?.data || null;
  }
};
